/**
 * The store locator's one map.
 *
 * Four shops could mean four embedded maps, which is four third-party iframes
 * and a slow page on a phone. Instead the page carries one map and the shop
 * list moves it, which is also how a customer actually reads the page: they
 * pick a shop, then look at where it is.
 *
 * The iframe src is swapped rather than the whole element replaced, so the
 * browser keeps one frame for the life of the page.
 */
(function () {
  'use strict';

  function init(root) {
    var frame = root.querySelector('[data-tc-loc-map]');
    var items = [].slice.call(root.querySelectorAll('[data-tc-loc-item]'));
    if (!frame || !items.length) return;

    function show(item, moveFocus) {
      var q = item.getAttribute('data-q');
      if (!q) return;
      items.forEach(function (el) {
        el.setAttribute('aria-current', el === item ? 'true' : 'false');
      });
      frame.src = 'https://www.google.com/maps?q=' + encodeURIComponent(q) + '&z=15&output=embed';
      frame.title = item.getAttribute('data-name') || 'Map';
      // On a phone the map sits above the list, so a tap that changes it
      // otherwise looks like nothing happened.
      if (moveFocus && window.matchMedia('(max-width: 1000px)').matches) {
        frame.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () { show(item, true); });
    });

    var current = root.querySelector('[data-tc-loc-item][aria-current="true"]') || items[0];
    show(current, false);
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-tc-locator]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor rebuilds a section without reloading the page.
  document.addEventListener('shopify:section:load', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-tc-locator]')).forEach(init);
  });
})();
